import React from 'react';
import MergeTagResolver from "./MergeTagResolver";
import RichTextRenderer from "../RichTextRenderer";
import defaultStyles from "./defaultStyles";
import isWhiteSpace from './isWhiteSpace';

export default function RichText({ node, property, element, ...rest }) {
    const whiteSpace = isWhiteSpace(node);
    if (whiteSpace) {
        return null;
    }

    let themePrimary = property._theme ? property._theme.primaryColor : '#FF5733';
    // Simple Text
    let renderStyles = defaultStyles(themePrimary)
    if (element) {
        let elementStyle = Object.assign({}, defaultStyles[element]);
        let style = rest.style ? rest.style : {};
        renderStyles[element] = {...elementStyle, ...style};
    }

    // Resolve Embedded Entries
    const embeddedEntryResolver = (entry) => {
        switch (entry.sys.contentType.sys.id) {
            case 'mergeTag':
                return (
                    <MergeTagResolver
                        property={property}
                        mergeTag={entry.mergeTag}
                        defaultText={entry.defaultText}
                        renderStyles={renderStyles}
                    />
                );
            default:
                // TODO - Add error handling or logging when rendered embedded entry is not a known contentful type
                return null;
        }
    }

    return (
        <RichTextRenderer
            element={element}
            node={node}
            embeddedEntryResolver={embeddedEntryResolver}
            renderStyles={renderStyles}
        />
    );
}
